import React, { Fragment } from "react"
import classNames from "classnames"
import { isNil, isEmpty } from "ramda"

import styles from "./index.less"

const HiddenReadableText = ({ text }) =>
  !isNil(text) &&
  !isEmpty(text) && (
    <Fragment>
      <span className="rs_message" dangerouslySetInnerHTML={{ __html: `<!-- ${text} -->` }} />
      <br className={classNames("rs_pause", styles.hidden)} />
    </Fragment>
  )

export default HiddenReadableText
